import { useCreateManualAdjustmentMutation, ManualAdjustmentReasonType, IncrementOrDecrement } from '../../../graphql'
import { useShowSuccess, useShowError } from 'hooks/useToast'

export default function useAdjustItem() {
	const [ createManualAdjustment ] = useCreateManualAdjustmentMutation()
	const showSuccess = useShowSuccess()
	const showError = useShowError()

	return async(
		storeId: string,
		productId: string,
		quantity: number,
		cost: number,
		reason: ManualAdjustmentReasonType,
		direction: IncrementOrDecrement,
		memo?: string,
		vendorId?: string,
		purchaseOrderId?: string,
		purchaseId?: string,
	) => {
		const result = await createManualAdjustment( { variables: {
			inventoryLocationId: storeId,
			items: [ {
				productId,
				quantity,
				costPerItem: cost,
			} ],
			memo,
			reason,
			direction,
			vendorId,
			purchaseOrderId,
			purchaseId,
		} } )

		if ( result.data?.createManualAdjustment?.success ) {
			showSuccess( `createManualAdjustmentSuccess${Date.now()}`, result.data.createManualAdjustment.message )
		} else if ( result.data?.createManualAdjustment?.message ) {
			showError( `createManualAdjustmentError${Date.now()}`, result.data.createManualAdjustment.message )
		}
	}
}
